import React, { useEffect, useState } from 'react'
import {Row, Col,} from 'antd'
import { sendHttpPostRequest } from '../../../api/http-request'
import '../course.module.css'
import { checkUserLogin } from '../../common/user-center/user-info'
import Cookies from 'js-cookie'
import shiyanEmpty from '../../../static/image/empty/queshengye-shiyan.png'
import courseTeacherMenuStyles from "../menu/course-main-teacher-menu.module.less";
import { LockOutlined } from '@ant-design/icons';


import slidesStyles from '../slides/course-main-teacher-slides.module.less'
import caseStyles from '../../case/case.module.less'
import defaultCaseCover from '../../../static/image/case/default_case_cover.png'
import * as constants from '../../../constants/constants'

import Icon from '@ant-design/icons'
import { ReactComponent as eyeSvg }   from '../../../static/image/module/eye.svg'
const eyeIcon = (props:any) => (<Icon component={eyeSvg} {...props} />)



export interface Props {
  course_id: any,                
  is_pay: any,
  is_overdue: any
}


/** 平台课程实验列表页面 */
export const PlatformCourseCases: React.FC<Props> = (props) => {
  const { course_id, is_pay, is_overdue} = props
  const [casesList, setCasesList] = useState([] as any[]) //课程的实验

  const queryCases = () => {
    sendHttpPostRequest(
      'course/api/user_query_platform_course_cases',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        course_id: course_id,
      },
      (response: any) => {
        if (response.is_ok) {
          setCasesList(response.case_list)
        }
      }
    )
  }

  useEffect(() => {
    queryCases()
  }, [])


  const onPreviewCaseBtnClick = (record: any) => {
    if (!checkUserLogin()) {
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else {
      window.open(
        `/case-detail?case_id=${record.id}`
      )
    }
  }


  useEffect(() => {
    queryCases()
  }, [])


  return (
    <div >
      <Row gutter={[24, 24]} justify="start"  align="middle" wrap={true}>
        {casesList?.map((caseInterface) => {
          return (
            <Col span={6} key={caseInterface.case_id}>
              <div 
                className={caseStyles.caseCard} style={{height:'100%', width:'100%',border: '1px solid #e5e7eb'}}
              >

                <div className={caseStyles.caseCardCoverDiv} style={{height:100}}>

                    {caseInterface.cover == '' ? (
                      <img
                        alt=""
                        src={defaultCaseCover}
                        height={'100%'}
                        width={'100%'}
                        style={{
                          borderTopRightRadius: 12,
                          borderTopLeftRadius: 12,
                        }}
                      />
                    ) : (
                      <img
                        alt=""
                        src={
                          caseInterface.cover?.startsWith('http')
                            ? caseInterface.cover
                            : constants.BACKEND_URL +
                              caseInterface.cover
                        }
                        height={'100%'}
                        width={'100%'}
                        style={{
                          borderTopRightRadius: 12,
                          borderTopLeftRadius: 12,
                        }}
                      />
                    )}
                </div>
                
                <div className={caseStyles.caseCardContentDiv} style={{height:'100%'}}>

                  <div
                      style={{
                        textAlign: 'left',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        marginBottom:0
                      }}
                      title={caseInterface.name}

                      className={caseStyles.caseTitle}
                    >
                      {caseInterface.name}
                    </div>

                       
                </div>


                <Row wrap={false} align="middle" className={slidesStyles.actionDiv} style={{borderRadius:'0 0 12px 12px'}}>
                    <Col span={12} style={{textAlign:'left'}}>
                      <div>

                        </div>
                    </Col>
                    <Col span={12} style={{textAlign:'right'}}>
                      <div>
                         { is_pay == true && is_overdue == false ?   <span title="查看" className={slidesStyles.actionIconWrapper}
                          
                           onClick={is_pay == true && is_overdue == false  ? onPreviewCaseBtnClick.bind(this, caseInterface): ()=>{}} 
                           
                          ><Icon component={eyeIcon}/></span>  : <LockOutlined  className={courseTeacherMenuStyles.iconbuttons}/> }
 
                      </div>
                    </Col>
                  </Row>
            </div>
            </Col>
          )
        })}
      </Row>

        {casesList.length == 0 && (
          <div style={{ textAlign: 'center', paddingTop: 20 }}>
            <img src={shiyanEmpty} width={120} height={120} />
            <div style={{ color: '#999', marginTop: 10 }}>
              本课程暂时没有实验~
            </div>
          </div>
        )}
    </div>
  )
}

export default PlatformCourseCases
